module.exports = __webpack_public_path__ + "img/1495692664.231697d5.jpg";